import React, { useState, useEffect } from "react";
import { Page, Icon, Link, Button, f7, Segmented } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";

const EventRestDetailPage = ({ f7route }) => {
  const { id, rid } = f7route.params;
  const [data, setEventDetails] = useState([]);
  const [cancel, setCancelData] = useState({});
  let TotalAmount = 0;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [calculatedValues, setCalculatedValues] = useState({
    sub_total: 0,
    discount: 0,
    total_amt: 0,
    sales_tax: 0,
    tax: 0,
    total: 0,
  });
  useEffect(() => {
    // eventbycust/id/+ localStorage.getItem('id') +/?event_id=188
    axios
      .get(API_BASE_URL + "eventrestdetails/id/" + localStorage.getItem("id"), {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          event_id: id,
          rest_id: rid,
          cust_id: localStorage.getItem("id"),
        },
      })
      .then((response) => {
        setEventDetails(response.data.data);
        // let totalAmount = response.data.data[0].item?.rest_event?.map(
        //   (items, index) => (TotalAmount += items?.total_amount)
        // );

        // console.log("totalAmount", totalAmount);
        let total = 0;

        response.data.data?.map((item) =>
          item?.rest_event?.map(
            (items, index) => (total += items?.total_amount)
          )
        );

        const total_amt =
          total - response.data.data[0].discount > 0
            ? total - response.data.data[0].discount
            : 0;
        let sales_tax = 0;
        sales_tax = parseFloat(
          total_amt * (response.data.data[0].tax / 100)
        ).toFixed(2);
        const Total = parseFloat(total_amt) + parseFloat(sales_tax);

        setCalculatedValues({
          ...calculatedValues,
          discount: response.data.data[0].discount,
          tax: response.data.data[0].tax,
          sales_tax: sales_tax,
          total: parseFloat(Total).toFixed(2),
        });
      })

      .catch((error) => console.log(error));
  }, [id]);
  const showConfirm = (e) => {
    f7.dialog.confirm(
      "Need to accept bid?",
      "Accept Bid",
      () => {
        bidAcceptSubmit(e);
      },
      () => {
        // Cancel button clicked
        console.log("Cancel button clicked");
      }
    );
  };
  const showCancel = (e) => {
    f7.dialog.confirm(
      "Do you want to reject this bid?",
      "Confirmation",
      () => {
        bidCancelled(e);
      },
      () => {
        // Cancel button clicked
        console.log("Cancel button clicked");
      }
    );
  };
  const bidAcceptSubmit = (event) => {
    event.preventDefault();
    setIsButtonDisabled(true);
    const accept_array = {
      rest_id: rid,
      cust_id: localStorage.getItem("id"),
      event_status: 3,
      discount: calculatedValues.discount,
      sales_tax: calculatedValues.sales_tax,
    };
    // console.log(accept_array);

    axios
      .put(API_BASE_URL + "acceptbycust/id/" + id, accept_array, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.views.main.router.navigate(
          `/order_details/${response.data.order_id}/`
        );

        f7.toast
          .create({
            text: "Event Accepted ..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
        setIsButtonDisabled(false);
      })
      .catch((error) => {
        f7.dialog.alert("Error updating data!");
        setIsButtonDisabled(false);
      });
  };
  useEffect(() => {
    setCancelData({
      rest_id: rid,
      cust_id: localStorage.getItem("id"),
      type: "reject",
    });
  }, [rid]);
  const bidCancelled = () => {
    axios
      .put(API_BASE_URL + "canclevntbycust/id/" + id, cancel, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.views.main.router.navigate("/main/", {
          reloadAll: true,
        });
        f7.tab.show("#tab-3");
        f7.toast
          .create({
            text: "Event Cancelled ..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      })
      .catch((error) => f7.dialog.alert("Error updating data!"));
  };
  data?.map((item) =>
    item?.rest_event?.map(
      (items, index) => (TotalAmount += items?.total_amount)
    )
  );

  // useEffect(() => {
  //   const total_amt =
  //     TotalAmount - calculatedValues.discount > 0
  //       ? TotalAmount - calculatedValues.discount
  //       : 0;
  //   let sales_tax = parseFloat(
  //     total_amt * (calculatedValues.tax / 100)
  //   ).toFixed(2);
  //   setCalculatedValues({
  //     ...calculatedValues,
  //     sales_tax: sales_tax,
  //   });
  // }, [TotalAmount,]);
  const editEvent = (id) => {
    console.log(id);
    f7.views.main.router.navigate(`/edit_event/${id}/`);
  };

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Event Details</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>
          {data?.map((item) => (
            <section className="profile-form mt-3">
              <div className="custom-container p-0">
                <div class="title">
                  <h5 className="fw-bold dark-text dark-text">
                    <span className="light-text">Event ID : </span> {item.id}
                  </h5>
                  <a href="#" className="text-muted text-1">
                    {item.bid_start_date}
                  </a>
                </div>
                <div className="apply-coupon mt-3">
                  <h5>
                    Status:{" "}
                    <span className="text-success">
                      {item.order_event_status_txt}
                    </span>
                  </h5>
                </div>
                <table className="table 1table-borderless mt-2 text-2">
                  <tbody>
                    <tr>
                      <td width={"40%"}>Event Name: </td>
                      <td>
                        <b>{item.event_name}</b>
                      </td>
                    </tr>
                    <tr>
                      <td width={"40%"}>Event Date : </td>
                      <td>{item.event_date} </td>
                    </tr>
                    <tr>
                      <td>Event Size: </td>
                      <td>
                        {item.event_adult_size !== null &&
                          item.event_adult_size !== undefined && (
                            <span>
                              Adults - <strong>{item.event_adult_size}</strong>
                            </span>
                          )}
                        {item.event_kids_size !== null &&
                          item.event_kids_size !== undefined && (
                            <span>
                              , Kids - <strong>{item.event_kids_size}</strong>
                            </span>
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td>Food Need By Time: </td>
                      <td>{item.event_by_time}</td>
                    </tr>

                    <tr>
                      <td>Event Address: </td>
                      {item.delivery_type !== "Pick up" ? (
                        <td>
                          {item.add_lin_1} {item.add_lin_2} {item.city}{" "}
                          {item.state} {item.zip_code}
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>Deliver Type: </td>
                      <td>{item.delivery_type}</td>
                    </tr>

                    <tr>
                      <td>Event Notes: </td>
                      <td>
                        {item.event_note !== 0 ? <>{item.event_note}</> : null}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* <h3 className="fw-bold dark-text mb-2">Restaurant Information</h3> */}
                {/* <div className="vertical-product-box">
                <div className="vertical-box-img p-2" style={{width: '15%'}}>
                  <img alt="" slot="media" src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg" width="40" className="rounded-circle" />
                </div>
                <div className="vertical-box-details">
                  <div className="vertical-box-head">
                    <div className="restaurant">
                      <h5 className="dark-text">Ben &amp; Floren</h5>
                    </div>
                    <h6 className="food-items mb-2" style={{overflow: 'visible'}}><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> 8642 Yule Street, Arvada CO 80007</h6>                    
                  </div>              
                </div>
              </div> */}
              </div>
              <div className="custom-container p-0">
                <h3 className="fw-bold dark-text">Menu Items</h3>
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                    {item.event_item.map((items, index) => (
                      <tr>
                        <td width={"10%"} className="text-center">
                          {index + 1}.{" "}
                        </td>
                        <td>
                          <h5 className="dark-text fw-bold mb-1">
                            {items.menu_name}
                          </h5>
                          {items.note}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="custom-container p-0">
                <h3 className="fw-bold dark-text">Restaurant Menu Items</h3>
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                    {item.rest_event.map((rest_event, index) => (
                      <tr>
                        <td width={"10%"} className="text-center">
                          {index + 1}.{" "}
                        </td>
                        <td>
                          {rest_event.menu_name ===
                            rest_event.request_menu_name ||
                          rest_event.request_menu_name == null ? (
                            rest_event.status !== 1 ? (
                              <h5 className="dark-text fw-bold mb-1">
                                {rest_event.menu_name}
                              </h5>
                            ) : (
                              <h5
                                className="dark-text fw-bold mb-1"
                                style={{
                                  textDecoration: "line-through",
                                  color: "black",
                                  textDecorationColor: "red",
                                }}
                              >
                                {rest_event.menu_name}
                              </h5>
                            )
                          ) : (
                            <>
                              <div style={{ display: "flex" }}>
                                <h5 style={{ marginRight: "10px" }}>
                                  Requested:
                                </h5>
                                <h5
                                  className="dark-text fw-bold mb-1"
                                  style={{
                                    textDecoration: "line-through",
                                    color: "black",
                                    textDecorationColor: "red",
                                  }}
                                >
                                  {rest_event.request_menu_name}
                                </h5>
                              </div>

                              <h5 className="dark-text fw-bold mb-1">
                                {rest_event.menu_name}
                              </h5>
                            </>
                          )}
                          {rest_event.status !== 1 ? (
                            <span>
                              Size : {rest_event.menu_size_name}(
                              {rest_event.size}
                              )<br />
                              Tray : {rest_event.qty}
                              <br />
                              Price : $
                              {parseFloat(rest_event.total_amount).toFixed(2)}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="custom-container p-0">
                <h3 className="fw-bold dark-text">Restaurant Information</h3>
                <table className="table table-striped table-sm text-2 mt-2">
                  <tbody>
                    {item?.rest_data?.map((restaurant, index) => (
                      <tr className="align-middle">
                        <td width={"10%"} className="text-center">
                          {index + 1}.{" "}
                        </td>
                        <td>
                          <h5 className="dark-text fw-bold mb-1">
                            {restaurant.rest_name}
                          </h5>
                          <span>
                            {restaurant.add_lin_1}, {restaurant.city}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <section className="bill-details mb-0">
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Est Rate Details</h3>
                  <table className="table table-sm mt-2 text-2">
                    <tbody>
                      {item.is_direct_order === 0 ? (
                        <>
                          <tr>
                            <td className="mb-1">Sub Total </td>
                            <td className="text-end">
                              {" "}
                              ${parseFloat(TotalAmount)?.toFixed(2)}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            {/* <td className="dark-text fw-bold mb-1">Discount </td><td className='text-end'> ${formData.discount > 0 ? formData.discount:0 }</td><td> </td> */}
                            <td className="mb-1">Discount </td>
                            <td className="text-end">
                              {" "}
                              $
                              {parseFloat(calculatedValues?.discount)?.toFixed(
                                2
                              )}
                            </td>
                            <td> </td>
                          </tr>
                          <tr>
                            {/* <td className="dark-text fw-bold mb-1">Sales Tax </td><td className='text-end'> ${formData.discount > 0 ? formData.grand_total - formData.discount :formData.grand_total}</td><td></td> */}
                            <td className="mb-1">
                              Sales Tax ({calculatedValues.tax}%)
                            </td>
                            <td className="text-end">
                              {" "}
                              ${calculatedValues?.sales_tax}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td className=" mb-1">Total </td>
                            <td className="text-end fw-bold">
                              {" "}
                              ${calculatedValues?.total}
                              {/* {parseFloat(
                                TotalAmount -
                                  parseFloat(calculatedValues.discount) +
                                  parseFloat(calculatedValues.sales_tax)
                              )?.toFixed(2)} */}
                            </td>
                            <td></td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td>Est Total</td>
                          <td className="text-end fw-bold">
                            ${parseFloat(TotalAmount).toFixed(2)}
                          </td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>
              {item.order_event_status === 2 ? (
                <div className="mt-0">
                  {item.is_direct_order === 0 ? (
                    <>
                      <div className="custom-container p-0">
                        <Button
                          className="btn btn-warning w-100 mt-0 mt-0"
                          onClick={() => editEvent(id)}
                          large
                          role="button"
                        >
                          Edit Event
                        </Button>
                      </div>
                      <Segmented raised tag="p" className="mb-3">
                        <Button
                          large
                          className="btn-success"
                          disabled={isButtonDisabled}
                          onClick={showConfirm}
                        >
                          Accept Bid
                        </Button>
                        <Button
                          large
                          className="btn-danger"
                          onClick={showCancel}
                        >
                          Reject Bid
                        </Button>
                      </Segmented>
                    </>
                  ) : (
                    <>
                      <div
                        className="apply-coupon mt-3"
                        style={{
                          marginBottom: "12px",
                        }}
                      >
                        <span className="text-success">
                          <span style={{ color: "#F43F5E" }}> *</span>
                          &nbsp; For further inquiries contact the restaurant
                        </span>
                      </div>
                      <Button
                        className="btn-danger"
                        onClick={showCancel}
                        large
                        role="button"
                        style={{ marginBottom: "5px" }}
                      >
                        Reject Order
                      </Button>
                    </>
                  )}
                  {/* <div className="custom-container p-0 mt-3 mb-3">
                  <Button type="submit" className="btn btn-success w-100 mt-0" disabled={isButtonDisabled} onClick={showConfirm} large role="button">Accept Bid</Button>
              </div>
              <div className="custom-container p-0 mt-3 mb-3">
                <Button type="submit" className="btn btn-danger w-100 mt-0" onClick={showCancel} large role="button">Reject Bid</Button>
              </div> */}
                </div>
              ) : (
                ""
              )}
            </section>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default EventRestDetailPage;
